// USA
export const locale = {
	lang: 'English',
	img: 'english.jpg',
	data: {
		MENU: {
			DASHBOARD: 'Home',
			USER_MANAGER: 'User Manager',
			DEVICE_MANAGER: 'Device Manager',
			DATA_MANAGER: 'Data Manager',
			REALTIME_DASHBOARD: 'Realtime Dashboard',
			DEV_CENTER: 'Development Manager',
			FIRMWARE_MANAGER: 'Firmware Manager',
			DATA_DISTRIBUTION: 'Data Distribution',
			EDGE_COMPUTING: 'Edge Computing',
			PRODEVICE_MANAGER: 'Product Manager',
			APP_VERSION: 'App Version',
			FEEDBACK: 'Feedback Manager',
			MESSAGE: 'Message Manager',
			SETTINGS: 'Settings',
			DOCUMENT: 'Document',
			REVIEW_DEVELOPERS: 'Developers review',
			REVIEW_DEVICES: 'Product review',
			BASE_SETTINGS: 'Base Settings',
			ADMIN: 'Administrator',
			CONFIG_EDITOR: 'Config Editor',
			KEY_MANAGER: 'Key Manager',
			ORDER_MANAGER: 'Order Manager',
			PLATFORM_MANAGER: 'IOT Platform Manager',
			COAP_MANAGER: 'CoAP Manager',
			VENDOR_MANAGER: 'Vendor Manager',
			WX_PUSH: 'WeChat Push Manager',
			SECURITY_MANAGER: 'Security Manager'
		},
		WX_PUSH: {
			LIST: 'Push Records',
			INFO: 'Push Detail',
			TITLE: 'WeChat Push Manager',
			STATS: 'Push Statistics',
			TOTAL: 'Total Pushes',
			SUCCESS: 'Success',
			FAILED: 'Failed',
			SUCCESS_RATE: 'Success Rate',
			PUSH_TYPE: 'Push Type',
			DEVICE_NAME: 'Device Name',
			STATUS: 'Status',
			ERROR_MSG: 'Error Message',
			CREATE_TIME: 'Create Time',
			FILTER_UUID: 'Filter by User UUID',
			FILTER_TYPE: 'Filter by Type',
			FILTER_STATUS: 'Filter by Status',
			TYPE_TEMPLATE: 'Template Message',
			TYPE_CUSTOMER: 'Customer Message',
			TYPE_ALERT: 'Device Alert',
			TYPE_AUTOMATION: 'Automation Notify',
			TEST_PUSH: 'Test Push',
			REFRESH: 'Refresh'
		},
		VENDOR: {
			LIST: 'Vendor List',
			INFO: 'Vendor Detail',
			TOTAL: 'Total Vendors',
			ACTIVE: 'Active Vendors',
			MINIPROGRAM_COUNT: 'Miniprogram Count',
			CHANNEL_USERS: 'Channel Users'
		},
		USER_MENU: {
			PROFILE: 'User Profile',
			LOGOUT: 'Logout'
		},
		HOME: {
			DEVICE: 'Device',
			DATA: 'Data',
			SERVICE: 'Service',
			OTHER: 'Other',
			ACCOUNT: 'Account'
		},
		USER: {
			LIST: 'User List',
			INFO: 'User info',
			GROUP0: 'User',
			GROUP1: 'Professional',
			GROUP2: 'Education',
			PHONE: 'Phone',
			DIYDEVICE_NUM: 'Diy Device',
			PRODEVICE_NUM: 'Pro Device',
			ACCOUNT: 'Other Account',
			EXPIRE: 'Expire Date'
		},
		DEVICE: {
			LIST: 'Device List',
			INFO: 'Device Info',
			STATE: 'State',
			ONLINE: 'Online',
			OFFLINE: 'Offline',
			FIRMWARE_VERSION: 'Firmware Verison',
			ADDRESS: 'Address',
			DEVICETYPE: 'Type',
			MODE: 'Mode',
			DATA: 'Data Storage',
			ACCOUNT: 'Other Account',
			BROKER: 'Broker',
		},
		DATA: {
			LIST: 'Data List',
			INFO: 'Data Info',
			LINE: 'Line',
			BAR: 'Bar',
			NODATA: 'No Data',
		},
		PRODEVICE: {
			LIST: 'Product List',
			INFO: 'Product Info',
			VENDER: 'Vender',
			ICON: 'Icon',
			COMPONENT: 'Component',
			MODE: 'Mode',
			CONFIGURATOR: 'Configurator',
			SPEECH: 'Speech',
			TIMER: 'Timer',
			DESCRIPTION: 'Description',
			GUIDE: 'Guide',
			PUBLISH_STATE: 'Publish State',
			PUBLISHED: 'Published',
			UNPUBLISHED: 'Unpublished',
			PENDING: 'Pending',
			REJECT: 'Reject',
			ACTIONS: 'Actions',
			TRIGGERS: 'Triggers'
		},
		FIRMWARE: {
			LIST: 'Firmware List',
			INFO: 'Firmware Info',
			VERSION: 'Verison',
			SIGN: 'Sign',
			SIZE: 'Size',
			DATE: 'Date',
			DESCRIPTION: 'Description',
			TOTAL_NUM: 'Total',
			CURRENT_NUM: 'Current'
		},
		APP: {
			LIST: 'App List',
			INFO: 'App Info',
		},
		FEEDBACK: {
			LIST: 'Feedback List',
			INFO: 'Feedback Info',
			TYPE: 'Type',
			CONTENT: 'Content'
		},
		MESSAGE: {
			LIST: 'Message List',
			INFO: 'Message Info',
		},
		REVIEW_DEVELOPER: {
			LIST: 'Review List',
			INFO: 'Review Info',
			USERNAME: 'Username',
			PHONE: 'Phone',
			VENDER: 'Vender',
			IDCARD: 'ID Card',
			LICENSE: 'License',
			CREAT_DATE: 'Creat Date',
			STATE: 'State',
			REMARKS: 'Remarks',
			REJECT: 'Reject',
			PENDING: 'Pending',
			PASS: 'Pass'
		},
		REVIEW_DEVICES: {
			LIST: '审核列表',
			INFO: '审核详情'
		},
		ACTION: {
			TEXT: 'Actions',
			GOTO_DEVICE: 'View Device',
			CHANGE_PASSWORD: 'Change Password',
			CHANGE_GROUP: 'Change Group',
			DELETE_USER: 'Delete User',
			GOTO_USER: 'View User',
			GOTO_DATA: 'View Data',
			SHOW_LOG: 'View Log',
			SHOW_OBJECT: 'View Shadow',
			DELETE_DEVICE: 'Delete Device',
			GET_API: 'View Api',
			DELETE_DATA: 'Delete Data',
			DOWNLOAD_FIRMWARE: 'Download Firmware',
			TEST_FIRMWARE: 'Test Firmware',
			PUBLISH_FIRMWARE: 'Publish Firmware',
			DELETE_FIRMWARE: 'Delete Firmware',
			RESOLVE_FEEDBACK: 'Resolve',
			DELETE_FEEDBACK: 'Delete',
			DELETE_MESSAGE: 'Delete',
			PUBLISH_PRODEVICE: 'Publish Product',
			SHOW_KEY: 'Get Key',
			DELETE_PRODEVICE: 'Delete Product',
			REVIEW_PASS: 'Pass',
			REVIEW_REJECT: 'Reject'
		},
		TIME: {
			H1: '1 Hour',
			H24: '24 Hours',
			D7: '7 Days',
			D30: '30 Days',
			Y1: '1 year'
		},
		OTHER: {
			AVG: 'average',
			MAX: 'max',
			MIN: 'min'
		},
		USERKEYS: {
			LIST: 'User keys list',
			INFO: 'User key info',
			ACCESSKEY: 'AccessKey',
			SECRETKEY: 'SecretKey',
			STATUS: 'status',
			CREATEDAT: 'created at'
		},
		ORDER: {
			LIST: 'Order List',
			INFO: 'Order Info',
			ID: 'Order Id',
			STATE: 'State',
			PAID: 'Paid',
			PENDING: 'Pending',
			CLOSED: 'Closed',
			PAY: 'Pay'
		}
	}
};